module.exports = __webpack_public_path__ + "static/media/history-track.8f3dbb66.svg";